<template>
  <div class="of-box">
    <div class="of-container is-vertical base-page-box">
      <div class="of-aside base-search-box">
        <div class="of-filter clearfix">
          <div class="filter-left">
            <el-button
              v-access:export
              type="primary"
              size="small"
              icon="fa fa-cloud-download"
              :disabled="exportDisabled"
              :loading="exportLoading"
              @click="ExportAction()"
            >导出</el-button>
            <el-button
              v-access:export
              type="primary"
              size="small"
              icon="fa fa-cloud-download"
              :disabled="exportDisabled"
              :loading="exportLoading"
              @click="ExportCollectingAction()"
            >导出领用记录</el-button>
          </div>
          <div class="filter-right">
            <!-- <el-input v-model="pageQuery.fastSearchKeyWord"
                      placeholder="请输入关键字搜索"
                      size="small"
                      clearable
                      prefix-icon="fa fa-search"
                      @change="search"></el-input> -->
            <el-popover
              ref="popoverDom"
              placement="bottom-start"
              width="320"
              popper-class="el_popover_class"
              trigger="click"
            >
              <div>
                <div>
                  <el-form
                    label-width="80px"
                    :model="pageQuery"
                    class="search-form"
                  >
                    <el-form-item
                      label="项目"
                      size="small"
                      class="search-form-item"
                    >
                      <el-select
                        v-model="pageQuery.ProjectId"
                        clearable
                        filterable
                        placeholder="请选择项目"
                      >
                        <el-option
                          v-for="item in ProjectOpts"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="仓库"
                      size="small"
                      class="search-form-item"
                    >
                      <el-select
                        v-model="pageQuery.WarehouseId"
                        clearable
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in warehouseList"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="动作"
                      size="small"
                      class="search-form-item"
                    >
                      <el-select
                        v-model="pageQuery.InventoryType"
                        clearable
                        placeholder="请选择动作"
                      >
                        <el-option
                          v-for="item in InventoryTypeOpts"
                          :key="item.index"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="供应商"
                      class="search-form-item"
                    >
                      <el-input
                        v-model="pageQuery.SupplierName"
                        placeholder="请输入供应商"
                        size="small"
                        clearable
                        prefix-icon="fa fa-search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="单号"
                      class="search-form-item"
                    >
                      <el-input
                        v-model="pageQuery.InventNo"
                        placeholder="请输入单号"
                        size="small"
                        clearable
                        prefix-icon="fa fa-search"
                      ></el-input>
                    </el-form-item>

                    <!-- <el-form-item label="类型"
                                       size="small"
                                       class="search-form-item">
                           <el-select v-model="pageQuery.Type"
                                      clearable
                                      placeholder="请选择类型">
                             <el-option label="入库"
                                        value="入库"> </el-option>
                             <el-option label="出库"
                                        value="出库"> </el-option>
                             <el-option label="调拨入库"
                                        value="调拨入库"> </el-option>
                             <el-option label="调拨出库"
                                        value="调拨出库"> </el-option>
                           </el-select>
                         </el-form-item> -->

                    <el-form-item
                      label="物品种类"
                      size="small"
                      prop="TypeId"
                      class="search-form-item"
                    >
                      <el-cascader
                        v-model="typeIdList"
                        :options="options"
                        filterable
                        :props="{ label: 'text', value: 'id' }"
                        @change="typeChange"
                      ></el-cascader>
                    </el-form-item>

                    <el-form-item
                      label="物品"
                      size="small"
                      class="search-form-item"
                    >
                      <el-select
                        v-model="pageQuery.materialId"
                        clearable
                        filterable
                        placeholder="请选择物品"
                      >
                        <el-option
                          v-for="item in infoList"
                          :key="item.Id"
                          :label="item.Name"
                          :value="item.Id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      label="状态"
                      size="small"
                      class="search-form-item"
                    >
                      <el-select
                        v-model="pageQuery.Status"
                        clearable
                        filterable
                        placeholder="请选择状态"
                      >
                        <el-option
                          label="调拨中"
                          value="11"
                        >
                        </el-option>
                        <el-option
                          label="入库中"
                          value="21"
                        >
                        </el-option>
                        <el-option
                          label="出库中"
                          value="31"
                        >
                        </el-option>
                        <el-option
                          label="已出库"
                          value="32"
                        >
                        </el-option>
                        <el-option
                          label="使用人签名中"
                          value="33"
                        >
                        </el-option>
                        <el-option
                          label="已同意"
                          value="97"
                        >
                        </el-option>
                        <el-option
                          label="强制完结"
                          value="98"
                        >
                        </el-option>
                        <el-option
                          label="已完结"
                          value="99"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      label="关键字"
                      class="search-form-item"
                    >
                      <el-input
                        v-model="pageQuery.fastSearchKeyWord"
                        placeholder="操作人"
                        size="small"
                        clearable
                        prefix-icon="fa fa-search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="操作时间"
                      size="small"
                      class="search-form-item"
                    >
                      <el-date-picker
                        v-model="DispatchDate"
                        placeholder="请选择"
                        style="width: auto;"
                        format="yyyy-MM-dd [           ] HH:mm:ss"
                        type="datetimerange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                        @change="dateChange"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <div
                      class="btns"
                      style="text-align: left;padding-top: 5px;"
                    >
                      <el-button
                        type="primary"
                        size="small"
                        @click="search"
                      >查 询</el-button>
                      <el-button
                        type="primary"
                        size="small"
                        @click="resetsSearch"
                      >重 置</el-button>
                    </div>
                  </el-form>
                </div>

              </div>
              <el-button
                size="small"
                style="margin-left:10px;"
                slot="reference"
                @click="advSearch = (advSearch ? 0 : 1); initPageBoxHeight()"
                icon="el-icon-search"
              >
                高级搜索</el-button>
            </el-popover>
            <!-- <el-button
              type="primary"
              size="small"
              @click="advSearch=(advSearch?0:1);initPageBoxHeight()"
            >高级搜索</el-button> -->
          </div>
        </div>

      </div>
      <div
        ref="tableBox"
        class="of-main no-scroll"
      >
        <div class="of-table">
          <el-table
            v-loading="isloading"
            border
            stripe
            resizable
            :data="listData"
            style="width: 100%"
            size="small"
            :height="boxHeight"
            :header-cell-style="{ background: '#f2f3f5' }"
          >
            <el-table-column
              v-for="(item, index) in tableCols"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              header-align="left"
              :align="item.align"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="item.shwotip"
                  :content="`${scope.row[item.prop]}`"
                  placement="bottom"
                  effect="light"
                >
                  <span>{{ scope.row[item.prop] }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.FlowBusinessId !== null"
                  v-access:read
                  class="table-ctrlbtn"
                  style="margin-right: 8px;"
                  size="small"
                  icon="fa fa-calendar"
                  @click="getInstanceLog(scope.row)"
                >流程日志</el-button>
                <el-button
                  v-access:read
                  class="table-ctrlbtn"
                  icon="el-icon-view"
                  size="small"
                  style="margin-right: 8px;"
                  @click="OutStockDetail(scope.row)"
                >预览</el-button>
                <!-- <el-button v-if="scope.row.InventoryType == '入库' || scope.row.InventoryType == '出库'"
                           v-access:manager
                           class="table-ctrlbtn"
                           icon="el-icon-s-opportunity"
                           size="small"
                           @click="WithdrawDetail(scope.row.Id)">冲销</el-button> -->
                <!-- <el-dropdown class="table-ctrlbtn" @command="menuClick">
                  <el-button size="small" icon="fa fa-ellipsis-v"></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-show="scope.row.InventoryType == '出库' && scope.row.Status >= 32"
                      :command="{ 'type': 'OutStockDetail', 'data': scope.row }">出库记录</el-dropdown-item>
                    <el-dropdown-item v-show="scope.row.InventoryType == '入库' || scope.row.InventoryType == '出库'"
                      v-access:manager :command="{ 'type': 'WithdrawDetail', 'data': scope.row }">冲销</el-dropdown-item>
                  </el-dropdown-menu>

                </el-dropdown> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="of-aside">
        <my-pagination
          :total="total"
          :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex"
          @change="pageChange"
        ></my-pagination>
      </div>
    </div>
    <InstanceLog v-model="RowModel"></InstanceLog>
    <dialogue
      :visible="showPrint"
      :title="myForm.title"
      width="60%"
      @onCancel="() => { showPrint = false }"
    >
      <preForm
        v-if="showPrint"
        slot="content"
        ref="printForm"
        :data="myForm.form"
        :collectorSign="CollectorSignSrc"
        :checkSign="checkSignSrc"
      ></preForm>
      <template slot="footer">
        <el-button
          size="small"
          @click="showPrint = false"
        >关 闭</el-button>
        <!-- <el-button size="small" v-print="printboj" type="primary">打 印</el-button> -->
        <el-button
          size="small"
          :loading="isPdfDownLoad"
          @click="pdfDownLoad"
          type="primary"
        >PDF下载</el-button>

      </template>
    </dialogue>
    <dialogue
      :visible="isShowPreview"
      :title="myForm.title"
      width="60%"
      @onCancel="() => { isShowPreview = false }"
    >
      <preDetailListForm
        v-if="isShowPreview"
        slot="content"
        ref="printDetailListForm"
        :data="previewData"
      >
      </preDetailListForm>
      <template slot="footer">
        <el-button
          size="small"
          @click="isShowPreview = false"
        >关 闭</el-button>
        <!-- <el-button size="small" v-print="printboj" type="primary">打 印</el-button> -->
        <el-button
          size="small"
          :loading="isPdfDownLoad"
          @click="pdfDownLoad1"
          type="primary"
        >PDF下载</el-button>
      </template>
    </dialogue>
  </div>
</template>

<script>
import { SearchQueryDetailList, DetailExport, DetailCollectingExport, ExportDetailedList, withdrawDetail, stockDetailPdfDownLoad, CreateStockPdfPreviewByDetailId } from "@/modules/material/api/inventory.js";
import { getAllUsableList as getAllInfoList } from "@/modules/material/api/info.js";
import { getAllUsableList as getAllWarehouseList } from "@/modules/material/api/warehouse.js";
import { getBaseSearchOptsHasIsolation } from '@/modules/report/api/baseSearch'
import { getAllUsableList, loadJsTreeNodes } from "@/modules/material/api/type.js";
import InstanceLog from "@/modules/base/pages/task/instanceLog";
import { getInstanceByBusinessId } from "@/modules/base/api/commonInstance.js";
import dialogue from '@/components/dialogue'
import preForm from '@/modules/material/pages/inventoryDetail/print.vue'
import preDetailListForm from '@/modules/material/pages/inventoryDetail/outStockDetailPrint_bak.vue'
import MyPagination from "@/components/pagination";
export default {
  name: "InventoryDetail",
  components: {
    MyPagination,
    InstanceLog,
    preForm,
    dialogue,
    preDetailListForm
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return { projectId: '' }
      }
    }
  },
  data () {
    return {
      pageQuery: {
        Status: '',
        pageSize: 50,
        pageIndex: 1,
        sortOrder: "desc",
        sortField: "ActionDate",
        fastSearchFields: "ActionEmployeeName,InventNo,DetailNo",
        fastSearchKeyWord: "",
        Type: '',
        SupplierName: '',
        materialId: null,
        WarehouseId: null,
        ProjectId: null,
        StartTime: null,
        EndTime: null,
        InventoryType: '',
        DetailNo: ''
      },
      previewData: null,
      isShowPreview: false,
      checkSignSrc: '',
      CollectorSignSrc: '',
      RowModel: {},
      printboj: {
        id: 'printBox',
        popTitle: '&nbsp;', // 打印配置页上方的标题
      },
      exportLoading: false,
      exportDisabled: false,
      tableCols: [
        { label: "项目", prop: "ProjectName", width: "150", type: "", shwotip: true },
        { label: "仓库名称", prop: "WarehouseName", type: "", shwotip: true },
        { label: "供应商名称", prop: "SupplierName", type: "", width: "160", shwotip: true },
        { label: "动作", prop: "InventoryType", width: "100", type: "" },
        { label: "单号", prop: "InventNo", width: "120", type: "", shwotip: true },
        { label: "送货单号", prop: "RemarkInventNo", width: "120", type: "", shwotip: true },
        { label: "物品种类", prop: "MaterialTypeName", width: "100", type: "", shwotip: true },
        { label: "物品名称", prop: "MaterialName", width: "120", type: "", shwotip: true },
        { label: "出入库数量", prop: "Numbers", width: "100", type: "", align: 'right' },
        { label: "单价(不含税)", prop: "UnitPrice", width: "100", type: "", align: 'right' },
        { label: "总价格(不含税)", prop: "AllPrice", width: "100", type: "", align: 'right' },
        { label: "单价(含税)", prop: "TaxUnitPrice", width: "100", type: "", align: 'right' },
        { label: "总价格(含税)", prop: "TaxAllPrice", width: "100", type: "", align: 'right' },
        { label: "状态", prop: "StatusName", width: "100", type: "" },
        { label: "操作时间", prop: "ActionDateStr", width: "160", type: "" },
        { label: "操作人", prop: "ActionEmployeeName", width: "100", type: "" },
      ],
      InventoryTypeOpts: [
        { label: "入库", value: "入库" },
        { label: "出库", value: "出库" },
        { label: "调拨入库", value: "调拨入库" },
        { label: "调拨出库", value: "调拨出库" }
      ],
      myForm: {
        form: null,
        title: ''
      },
      showPrint: false,
      total: 0,
      listData: [],
      isloading: false,
      boxHeight: 0,
      advSearch: 0,
      types: [],
      options: [],
      typeIdList: [],
      pageHeight: 0,
      infoList: [],
      DispatchDate: [],
      infos: [],
      warehouseList: [],
      baseInfo: null,
      detailInfo: null,
      isPdfDownLoad: false

    };
  },
  computed: {
    ProjectOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.PlateName)
          return this.baseInfo.AllProList.filter(p => { return !p.ParentId && p.Plate == this.pageQuery.PlateName }).map(p => { return { id: p.Id, name: p.Name } })
        return this.baseInfo.AllProList.filter(p => { return !p.ParentId }).map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
  },
  mounted () {
    this.initOpt()
    this.initPageBoxHeight()
    if (!this.options || this.options.length == 0) {
      loadJsTreeNodes(true).then((rep) => {
        if (rep.data.Code == 0) {
          this.options = rep.data.Data
        }
      })
    }
    if (this.infoList.length == 0) {
      getAllInfoList().then((x) => {
        if (x.data.Code == 0) {
          this.infoList = x.data.Data;
          this.infos = x.data.Data;
        }
      });
    }
    if (this.warehouseList.length == 0) {
      getAllWarehouseList().then((x) => {
        if (x.data.Code == 0) this.warehouseList = x.data.Data;
      });
    }
    if (this.params.projectId) {
      this.pageQuery.ProjectId = this.params.projectId
    }
    this.loadPageData();
    this.mixinTableHeight(0);
  },
  methods: {
    dateChange (val) {
      if (val == null) {
        this.pageQuery.StartTime = null
        this.pageQuery.EndTime = null
      }
    },
    showPrintView (row) {
      this.myForm.form = row
      this.detailInfo = row
      this.myForm.title = `打印【${row.InventNo}】${row.InventoryType}单`
      this.showPrint = true
    },
    resetsSearch () {
      this.pageQuery.Type = null
      this.pageQuery.materialId = null
      this.pageQuery.WarehouseId = null
      this.pageQuery.ProjectId = null
      this.pageQuery.pageIndex = 1
      this.pageQuery.fastSearchKeyWord = ''
      this.pageQuery.TypeId = ''
      this.pageQuery.Status = ''
      this.pageQuery.InventoryType = ''
      this.pageQuery.SupplierName = ''
      this.pageQuery.DetailNo = ''
      this.typeIdList = []
      this.pageQuery.StartTime = null
      this.pageQuery.EndTime = null
      this.DispatchDate = []
      this.infoList = this.infos
      if (this.params.projectId) {
        this.pageQuery.ProjectId = this.params.projectId
      }
      this.loadPageData()
    },

    loadPageData () {
      this.isloading = true;
      this.advSearch = 0
      if (this.DispatchDate && this.DispatchDate.length > 0) {
        this.pageQuery.StartTime = this.datetime(this.DispatchDate[0])
        this.pageQuery.EndTime = this.datetime(this.DispatchDate[1])
      }

      SearchQueryDetailList(this.pageQuery)
        .then((rep) => {
          this.isloading = false;
          let repData = rep.data;
          if (repData.Code == 0) {
            repData.Data.rows.forEach(element => {
              element.TaxUnitPrice = element.TaxUnitPrice.toFixed(2)
              element.TaxAllPrice = element.TaxAllPrice.toFixed(2)
              element.Numbers = element.Numbers.toFixed(2)
              element.AllPrice = element.AllPrice.toFixed(2)
              element.UnitPrice = element.UnitPrice.toFixed(2)
            })
          }
          this.total = repData.Data.total;
          this.listData = repData.Data.rows;
        })
        .catch((err) => (this.isloading = false));
    },
    initOpt () {
      getBaseSearchOptsHasIsolation().then(rep => {
        if (rep.data.Code == 0) {
          this.baseInfo = rep.data.Data
        }
      })
    },
    ExportDetail (row) {
      this.exportDisabled = true
      if (row.InventoryType == "入库") {
        ExportDetailedList(row.InventNo, row.InventoryType).then(rep => {
          this.exportDisabled = false
          if (rep.data.Code == 0) {
            window.open(
              `/common/CommonTemplateDown/DownExportWordFile?title=入库单表&&id=${rep.data.Data}`
            );
          } else {
            this.toast({ content: rep.data.Message, type: "warning" });
          }
        }).catch(() => {
          this.exportDisabled = false
        });
      }
      else {
        ExportDetailedList(row.InventNo, row.InventoryType).then(rep => {
          this.exportDisabled = false
          if (rep.data.Code == 0) {
            window.open(
              `/common/CommonTemplateDown/DownExportWordFile?title=出库单表&&id=${rep.data.Data}`
            );
          } else {
            this.toast({ content: rep.data.Message, type: "warning" });
          }
        }).catch(() => {
          this.exportDisabled = false
        });
      }
    },
    search () {
      this.pageQuery.pageIndex = 1;
      this.loadPageData();
      this.$refs.popoverDom.doClose()
    },
    ExportAction () {
      this.exportLoading = true
      DetailExport(this.pageQuery).then(rep => {
        if (rep.data.Code == 0) {
          this.exportLoading = false
          window.open(`/common/CommonTemplateDown/DownExportFile?ft=67&&id=${rep.data.Data}`)
        }
      }).catch(() => {
        this.exportLoading = false
      });
    },
    ExportCollectingAction () {
      this.exportLoading = true
      DetailCollectingExport(this.pageQuery).then(rep => {
        if (rep.data.Code == 0) {
          this.exportLoading = false
          window.open(`/common/CommonTemplateDown/DownExportFile?ft=117&&id=${rep.data.Data}`)
        }
      }).catch(() => {
        this.exportLoading = false
      });
    },
    initPageBoxHeight () {
      this.MixinBoxHeight(50, 'base-page-box', () => {
        let searchHeight = 60//this.advSearch ? this.getClassDomHeight('base-search-box') + 25 : 80
        this.boxHeight = this.boxHeight - searchHeight
      })
    },
    typeChange (val) {
      this.pageQuery.materialId = ''
      if (val.length != 0) {
        this.pageQuery.TypeId = val[val.length - 1]
        this.infoList = this.infos.filter(e => { return e.TypeId == val[val.length - 1] })
      }
    },
    pdfDownLoad () {
      this.isPdfDownLoad = true
      stockDetailPdfDownLoad(this.detailInfo.InventNo, this.detailInfo.InventoryType).then(res => {
        if (res.data.Code == 0) {
          window.open(`/common/CommonTemplateDown/DownExportPdfFile?ft=67&&id=${res.data.Data}`)
          this.isPdfDownLoad = false
        }
      })
    },
    pdfDownLoad1 () {
      this.isPdfDownLoad = true
      CreateStockPdfPreviewByDetailId(this.previewData).then(res => {
        if (res.data.Code == 0) {
          window.open(`/common/CommonTemplateDown/DownExportPdfFile?ft=67&&id=${res.data.Data}`)
          this.isPdfDownLoad = false
        }
      })
    },
    // 获取流程实例日志
    getInstanceLog (row) {
      var InventoryType = ''
      if (row.InventoryType == '出库') {
        InventoryType = 'outStockManage'
      }
      if (row.InventoryType == '入库') {
        InventoryType = 'onStockManage'
      }

      getInstanceByBusinessId(row.FlowBusinessId).then(res => {
        if (res.data.Code == 0) {
          this.$set(this.RowModel, "show", true);
          this.$set(this.RowModel, "InstanceId", res.data.Data);
        }
      })

    },
    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize;
      this.pageQuery.pageIndex = pindex;
      this.loadPageData();
    },
    WithdrawDetail (id) {
      this.msgBox({ content: '是否冲销', type: 'confirm' }).then(() => {
        withdrawDetail(id).then(rep => {
          this.isloading = true;
          if (rep.data.Code == 0) {
            this.toast({ content: '冲销成功', type: "success" });
            this.loadPageData();
          } else {
            this.toast({ content: rep.data.Message, type: "warning" });
            this.isloading = false;
          }
        })
      }).catch()
    },
    // 同批次出库明细
    OutStockDetail (data) {
      this.previewData = data.Id
      this.myForm.title = `打印【${data.InventNo}】出库单`
      this.isShowPreview = true
    },
    menuClick (command) {
      console.log(command)
      switch (command.type) {
        case 'WithdrawDetail':
          this.WithdrawDetail(command.data.Id)
          break
        case 'OutStockDetail':
          this.OutStockDetail(command.data)

          break
      }
    },
  },
};
</script>
